import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material';

import { publicPath } from '../../../utils/env/urlStrings';

const backgroundColor = '#f7f6ff';

export const StyledElectricityImageContainer = styled('div')(() => ({
    backgroundImage: `url('${publicPath}/assets/images/background/Electricity.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
}));

export const StyledTwoScreensWrapper = styled('div')(({ theme }) => ({
    height: '100vh',
    background: '#fff',
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.down(850)]: {
        display: 'grid',
        gridAutoFlow: 'row',
        gridTemplateColumns: '1fr',
    },
}));

export const StyledPurpleContainer = styled('div')<{ $background?: string }>(
    ({ $background }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: $background || backgroundColor,
    }),
);

export const StyledInput = styled(TextField)({
    display: 'flex',
});

export const StyledAlignedEndInput = styled(TextField)({
    '#vanity-url': {
        textAlign: 'end',
    },
});

export const StyledWidthWrapper = styled('div')<{ $width?: string }>(
    ({ $width }) => ({
        width: $width || '60%',
    }),
);

export const StyledLeftForgottenButton = styled(Button)({
    float: 'left',
    color: '#5b5b5b',
    background: '#ffffff',
    border: '1px solid #d6d6d6',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '17px',
    '&:hover': {
        color: '#5b5b5b',
        background: '#ffffff',
    },
});
